import { PUBLIC_WHATSAPP_DEFAULT_MESSAGE, PUBLIC_WHATSAPP_NUMBER } from '../config/env';

interface WhatsAppMessageContext {
  pickup?: string | null;
  pickupLat?: number | null;
  pickupLng?: number | null;
  dropoff?: string | null;
  dropoffLat?: number | null;
  dropoffLng?: number | null;
}

export function buildWhatsAppBookingMessage(context: WhatsAppMessageContext = {}): string {
  const parts = [PUBLIC_WHATSAPP_DEFAULT_MESSAGE || 'Hi, I want to book a bakkie'];

  if (context.pickup?.trim()) {
    parts.push(`Pickup: ${context.pickup.trim()}`);
  }
  if (isCoordinate(context.pickupLat) && isCoordinate(context.pickupLng)) {
    parts.push(`Pickup coordinates: ${formatCoordinate(context.pickupLat)}, ${formatCoordinate(context.pickupLng)}`);
  }

  if (context.dropoff?.trim()) {
    parts.push(`Drop-off: ${context.dropoff.trim()}`);
  }
  if (isCoordinate(context.dropoffLat) && isCoordinate(context.dropoffLng)) {
    parts.push(`Drop-off coordinates: ${formatCoordinate(context.dropoffLat)}, ${formatCoordinate(context.dropoffLng)}`);
  }

  return parts.join('\n');
}

export function buildWhatsAppBookingUrl(message = buildWhatsAppBookingMessage()): string | null {
  if (!PUBLIC_WHATSAPP_NUMBER) return null;
  return `https://wa.me/${PUBLIC_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function isWhatsAppBookingConfigured(): boolean {
  return Boolean(PUBLIC_WHATSAPP_NUMBER);
}

function isCoordinate(value: number | null | undefined): value is number {
  return Number.isFinite(value);
}

function formatCoordinate(value: number): string {
  return Number(value).toFixed(6);
}
